export const DeviceName = {
	Ios: 'ios',
	Web: 'web',
	Android: 'android',
	Other: 'other',
} as const
export type DeviceName = (typeof DeviceName)[keyof typeof DeviceName]

export const KeyEditMode = {
	Disabled: '0',
	Enabled: '1',
	DescriptionAndLimit: '2',
} as const
export type KeyEditMode = (typeof KeyEditMode)[keyof typeof KeyEditMode]
